module.exports = __webpack_public_path__ + "static/img/8.6781b8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/8.png
// module id = K1cU
// module chunks = 0